import { Locale } from '../../../../localization/LocalizationKeys';
import { linkFieldConfig } from '../../person/fields/utils/personFieldsUtils';

export const linkMaintainerSourceFieldConfig = linkFieldConfig(
  'maintainerSource',
  [
    'maintainerSource.code',
    'maintainerSource.heading',
  ],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Attribute.Maintainer_Source),
    additionalTableConfig: {
      width: 100
    },
    render: (record) => record.maintainerSource.heading,
  })
);
